import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/radix/dialog";
import { Loader2 } from "lucide-react";
interface ConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}
export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = t0 => {
  const $ = _c(17);
  const {
    open,
    onOpenChange,
    onConfirm,
    onCancel,
    isLoading
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogHeader><DialogTitle>Search All Properties?</DialogTitle><DialogDescription>You haven't selected a specific location. Would you like to search all properties in Bangalore?</DialogDescription></DialogHeader>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isLoading || $[2] !== onCancel) {
    t2 = <Button variant="link" onPress={onCancel} className="w-full sm:w-auto" isDisabled={isLoading}>Cancel</Button>;
    $[1] = isLoading;
    $[2] = onCancel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isLoading) {
    t3 = isLoading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Loading...</> : "Search Properties";
    $[4] = isLoading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isLoading || $[7] !== onConfirm || $[8] !== t3) {
    t4 = <Button onPress={onConfirm} className="w-full sm:w-auto" isDisabled={isLoading}>{t3}</Button>;
    $[6] = isLoading;
    $[7] = onConfirm;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <DialogContent className="sm:max-w-md">{t1}<DialogFooter className="flex flex-col gap-2 sm:flex-row sm:gap-2">{t2}{t4}</DialogFooter></DialogContent>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onOpenChange || $[14] !== open || $[15] !== t5) {
    t6 = <Dialog open={open} onOpenChange={onOpenChange}>{t5}</Dialog>;
    $[13] = onOpenChange;
    $[14] = open;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};